$(function () {  
  // Afficher plus de messages 
  let messagesBody = document.querySelector('.messages-body')
  if (messagesBody) {
    previousHeight = messagesBody.scrollHeight
    rendered = true
    $('.messages-body').mCustomScrollbar({
      theme:"dark-thin",
      mouseWheel:{ deltaFactor: 1200000 },
      callbacks:{
        onTotalScrollOffset: 100,
        whileScrolling:function(){
          if (this.mcs.top === 0 && rendered) {
            rendered = false
            elementMessageScroll = this
            const url =  $('.js-old-messages').data('url')
            if (url) {
              setCffLoader('show', '.messages-body') 
              axios.get(url)
              .then((response) => { 
                rendered = true
                setCffLoader('hide', '.messages-body')
                // Changer les images dans le site
                if (response.data.html) { 
                  $('.js-old-messages').data('url', response.data.url)
                  $(this).find('.mCSB_container').prepend(response.data.html)
                  $('.messages-body').mCustomScrollbar("scrollTo", previousHeight / 2 ,{scrollInertia:0});
                }
              })
            }
          }
        }
      }
    }).mCustomScrollbar("scrollTo","bottom",{scrollInertia:0});
  }
  // Afficher les contacts dans les messages 
  $(".discussions-messages").mCustomScrollbar({
    theme:"dark-thin",
    mouseWheel:{ deltaFactor: 1200000 },
    callbacks:{
      onTotalScroll:function(){
        const url =  $('.js-old-messages-contacts').data('url')
        if (url) {
          setCffLoader('show', '.wrap-discussions-messages-to-loader') 
          axios.get(url)
          .then((response) => { 
            setCffLoader('hide', '.wrap-discussions-messages-to-loader') 
            // Changer les images dans le site
            if (response.data.html) { 
              $('.js-old-messages-contacts').data('url', response.data.url)
              $(this).find('.mCSB_container').append(response.data.html)
            }
          })
        }
      }
    }
  })
  
  // Scroll sur les contacts dans page contacts
  $('.contacts-messages').mCustomScrollbar({
    theme:"dark-thin",
    mouseWheel:{ deltaFactor: 1200000 },
    callbacks:{
      onTotalScroll:function(){
        const url =  $('.js-contacts-nextpageurl').data('url')
        const query = '&q=' + $('.js-search-contacts').val()
        if (url) {
          setCffLoader('show', '.wrap-contacts-messages') 
          $(this).find('.cff__loading').show()
          axios.get(url + query)
          .then((response) => { 
            setCffLoader('hide', '.wrap-contacts-messages') 
            // Changer les images dans le site
            if (response.data.html) { 
              $('.js-contacts-nextpageurl').data('url', response.data.url)
              $(this).find('.mCSB_container').append(response.data.html)
            }
          })
        }
      }
    }
  })
  
  // Afficher/cacher le loader
  function setCffLoader(action = 'show', element = 'body') {
    
    if (action === 'show') {
      $(element).addClass('cff--loading--wrap')  
    } else {
      $(element).removeClass('cff--loading--wrap')  
    }
    
  }
  
  //!\ Ne pas le bouger d'ici
  $attachmentLabelDiv = $('label[for=attachment]')
  attachmentLabel = $attachmentLabelDiv.html() + '&nbsp;<i class="material-icons">attachment</i></button>'

  $('#send-message').submit(function(e) {
    // Supprimer les messages d'erreurs
    $('.help-block').remove()
    $('.form-group').removeClass('has-error')
    // Init du formulaire
    let dataMessagerie = new FormData();
    const attachment = document.getElementById('attachment').files[0]
    if (undefined !== attachment) {
      dataMessagerie.append('attachment', document.getElementById('attachment').files[0])
    }
    dataMessagerie.append('content', $('#content').val())
    
    const $form = $(this) 
    // Send
    axios.post($form.attr('action'), dataMessagerie)
    .then((response) => { 
      // Ajouter le message dans le fil
      if (response.data.html) { 
        const messagebody = $('.messages-body') 
        //Ajouter le message 
        messagebody.find('.mCSB_container').append(response.data.html)
        // Vider le textarea
        $('.messages-reply__textarea-content').val('')
        $('#attachment').val('')
        // Faire le scrollbotom
        messagebody.mCustomScrollbar("scrollTo","bottom",{scrollInertia:0})
        // Lancer l'audio
        new Audio('/files/notification.mp3').play()
        // Remmetre le label piece attaché
        $attachmentLabelDiv.html(attachmentLabel)
      }
    })
    .catch(function (error) {
      // Afficher les erreurs
      $.each(error.response.data.errors, function(field, message) {
        const $fieldDiv = $('#' + field)
        if ('attachment' == field) { 
          $attachmentLabelDiv.html(attachmentLabel)
          $('#attachment').val('')
        }
        $fieldDiv.parents('.form-group').addClass('has-error')
        $fieldDiv.after('<span class="help-block">' + message.join('') + '</span>')
      })
    })
    e.preventDefault()
  })

// Permet de faire une recherche de contacts dans la messagerie
$(".js-search-contacts-messages").typeahead({
  hint: true,
  highlight: true,
  minLength: 0
}, {
  source:  function (query, process) {
    if (0 !== query.length) {
      setCffLoader('show', '.wrap-discussions-messages-to-loader') 
    }
    return axios.get($(".js-search-contacts-messages").data('url') + '?q=' + query)
    .then((response) => {  
      renderedType = true
      // Changer les images dans le site
      setCffLoader('hide', '.wrap-discussions-messages-to-loader') 
      $('.discussions-messages').find('.mCSB_container').html(response.data.html)
    })
  },
  templates: {
    empty: [],
    header: [],
    
  }
})

// Permet de faire une recherche de contacts dans page contacts coté franchiseur 
$(".js-search-contacts").typeahead({
  hint: true,
  highlight: true,
  minLength: 0
}, {
  source:  function (query, process) {
    if (0 !== query.length) {
      setCffLoader('show', '.wrap-contacts-messages') 
    }
    return axios.get($('.js-search-contacts').data('url') + '?q=' + query)
    .then((response) => {  
      renderedType = true
      // Changer les images dans le site
      setCffLoader('hide', '.wrap-contacts-messages') 
      $('.contacts-messages').find('.mCSB_container').html(response.data.html)
      const countView = response.data.count > 1 ? response.data.count + ' Contacts' : response.data.count + ' Contact'  
      $('.count-contacts').html(countView)
    })
  },
  templates: {
    empty: [],
    header: [],
    
  }
})

// Afficher/cacher le loader
function setCffLoader(action = 'show', element = 'body') {
  if (action === 'show') {
    $(element).addClass('cff--loading--wrap')  
  } else {
    $(element).removeClass('cff--loading--wrap')  
  }
}
})


// WEBPACK FOOTER //
// ./resources/assets/js/components/messages.js